import {
    isArray,
    deepClone,
    deepMixin
} from "../../funcs";
import BaseApp from "../BaseApp";
import MainMenu from "./menu/MainMenu";
import MenuChannel from "./MenuChannel";
import MenuItem from "./menu/model/MenuItem";
import langDictionary from "../../classes/lang/init";

// Пункты, на которые есть права текущего пользователя
const MENU_RIGHTS_REPORTS = system.rights.getMenuReportRights().reports;

function shakeReportsByUserRights(items) {
    const result = [];

    for (const item of items) {
        if (
            item.action === "subMenu"
            && item.subMenu
            && item.subMenu.length
        ) {
            item.subMenu = shakeReportsByUserRights(item.subMenu);
            if ( item.subMenu.length ) {
                result.push(item);
            }
        }

        if ( item.action === "app" ) {
            const reportName = item.report ?? item.app ?? item.data.report;
            if ( reportName in MENU_RIGHTS_REPORTS ) {
                result.push(item);
            }
        }
    }
    return result;
}

export default class MenuApp extends BaseApp {
    channel() {return MenuChannel;}
    channelEvents() {
        return {
            addReportItems: "onChannelAddReportItems",
            addItem: "onChannelAddItem",
            removeItem: "onChannelRemoveItem",
            renameItem: "onChannelRenameItem",
            hide: "onChannelHide"
        };
    }

    onReady() {
        this.menu = new MainMenu();
        // LW-3358 пукнты отчетов загруженные не из БД
        this.reportItems = [];

        MenuApp.getReportItems = () => {
            const getSubMenuReportItems = () => {
                let reports = deepClone(this.reportItems);

                reports = reports
                    .map(((item) => {
                        if ( item.action === "subMenu" && item.subMenu ) {
                            return [...item.subMenu];
                        }
                        return item;
                    }));
                reports = reports.flat();
                reports = reports.filter((item) => item);

                return reports;
            };

            return system.hasModule("Voskhod")
                ? getSubMenuReportItems()
                : this.reportItems;
        };


    }

    onChannelAddReportItems(items) {
        items = deepClone(items);

        const reportItem = this.menu.items.find((model) =>
            model.get("icon") == "pie-chart" // why not?
        );

        if ( !reportItem ) {
            return;
        }

        if ( system.hasModule("Voskhod") ) {
            const dynamicReports = reportItem.get("subMenu");
            items = items.map((item) => {
                if ( item.action && item.action === "subMenu" ) {
                    const group = dynamicReports.find((rep) => rep.id == item.id);
                    if ( group && group.subMenu && group.subMenu.length ) {
                        item.subMenu = item.subMenu && item.subMenu.length
                            ? item.subMenu.concat(group.subMenu)
                            : group.subMenu;
                    }
                }
                return item;
            });
        }
        else {
            items = items.map((item) => {
                item._parentId = reportItem.id;
                return item;
            });
        }

        let data = reportItem.get("data") || {};
        let links = data.links;

        if ( !isArray(links) ) {
            links = [];
        }

        this.reportItems = links.concat(items);
        // LW-3358 для админа отобразим все
        if ( system.user.isAdmin() ) {
            data.links = links.concat(items);
        }
        else {
            data.links = links.concat(shakeReportsByUserRights(deepClone(items)));
        }

        // super mega fix
        if ( !isArray(data.subMenu) ) {
            data.subMenu = [];
        }

        // super mega fix  stage 2, Удалил баланс и оборотную ведомость, меню привратилось не в меню.
        if ( reportItem.get("action") != "subMenu" ) {
            reportItem.set("action", "subMenu");
        }

        // super mega fix stage 3,mainMenu проверяет subMenu внутри item, а не data
        if ( !reportItem.get("subMenu") ) {
            reportItem.set("subMenu", data.subMenu);
        }

        if ( system.hasModule("Voskhod") ) {
            reportItem.set("subMenu", data.links);
        }

        reportItem.set("data", data);
        // LW-3358 если есть дочерние загруженные отчеты необходимо показать родителя
        if ( data.links.length ) {
            reportItem.unset("display");
        }

        this.menu.view.itemsView.render();
        this.menu.view.$el.data("plugin_tinyscrollbar").update();
    }

    onChannelAddItem(params) {
        params = deepMixin({
            item: {
                action: "app",
                app: false,
                name: false,
                tableName: false,
                type: "Grid",
                listLevel: 0,
                icon: "default"
            },
            after: false // вставка после пункта ...
        }, params);

        let item = params.item;
        if ( !item ) {
            return;
        }

        item = {
            action: "app",
            app: item.app,
            name: item.title || langDictionary.getAppTitle(item.app),
            appParams: item.appParams,
            data: {
                tableName: item.tableName,
                type: item.type
            },
            listLevel: item.listLevel,
            icon: item.icon,
            id: Date.now() + "" + Math.random()
        };

        let items = this.menu.items;

        if ( params.after ) {
            let insertAfter = (after, menuArr, item) => {
                menuArr.forEach((elem, i, menuArr) => {
                    let app = (elem.attributes && elem.attributes.app) || elem.app;
                    let icon = (elem.attributes && elem.attributes.icon) || elem.icon;

                    if (
                        after.icon && after.icon == icon
                            || after.app && after.app == app
                    ) {
                        if ( item.listLevel === 0 ) {
                            let menuItem = new MenuItem(item);
                            items._byId[ menuItem.id ] = menuItem;
                            item = menuItem;
                        }
                        menuArr.splice(i + 1, 0, item);
                    }
                    else if ( elem.attributes && elem.attributes.subMenu ) {
                        insertAfter(after, elem.attributes.subMenu, item);
                    }
                });
            };

            insertAfter(params.after, this.menu.items.models, item);
        }
        else if ( params.into ) {
            let insertInto = (into, itemsArr, insertItem) => {
                itemsArr.forEach((menuItem) => {
                    menuItem = menuItem.attributes || menuItem;

                    let subMenu = menuItem.subMenu;
                    if ( !subMenu ) {
                        return;
                    }

                    let needInsert = (
                        into.icon && into.icon == menuItem.icon
                        || into.app && into.app == menuItem.app
                    );

                    if ( needInsert ) {
                        subMenu.push(insertItem);
                        return;
                    }

                    insertInto(into, subMenu, insertItem);
                });
            };

            insertInto(params.into, this.menu.items.models, item);

            // DynamicJournalBgApp добавляет в меню Аналатика
            // и если правами не открыли этот раздел,
            // то надо его открыть для DynamicJournalBgApp
            if ( params.into.icon == "pie-chart" ) {
                let reportItem = this.menu.items.find((model) =>
                    model.get("icon") == "pie-chart"
                );
                reportItem.unset("display");
            }
        }

        this.menu.view.itemsView.render();
        this.menu.view.$el.data("plugin_tinyscrollbar").update();
    }

    onChannelRemoveItem(item) {
        function removeItem(menuArr) {
            menuArr.some((elem, i) => {
                if ( elem.attributes && elem.attributes.subMenu ) {
                    removeItem(elem.attributes.subMenu);
                    return;
                }

                let app = (elem.attributes && elem.attributes.app) || elem.app;
                if ( !app ) {
                    return;
                }

                if ( item.app == app ) {
                    menuArr.splice(i, 1);
                    return true;
                }
            });
        }

        removeItem(this.menu.items.models);
    }

    // item: {app: "", newName: ""}
    onChannelRenameItem(item) {

        function renameItem(menuArr) {
            menuArr.some((elem) => {
                if ( elem.attributes && elem.attributes.subMenu ) {
                    renameItem(elem.attributes.subMenu);
                    return;
                }

                let app = (elem.attributes && elem.attributes.app) || elem.app;
                if ( !app ) {
                    return;
                }

                if ( item.app == app ) {
                    let attrs = (elem.attributes || elem);
                    attrs.name = item.newName;
                    return true;
                }
            });
        }

        renameItem(this.menu.items.models);
    }

    // LW-3358 передаем загруженные пункты
    getReportItems() {
        return this.reportItems;
    }

    onChannelHide() {
        this.menu.view.closeMenu();
    }
}
